<template>
  <html>
    <head>
      
    </head>
    <body>
      <navbar></navbar>

      <img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
      />
      <div class="title-page-l">
    <img
          class="img-profile"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-img-user.png"
        />
        <p>พรชนก งามสม</p>
        <h1>87,636</h1>
      </div>
<div class="contra">
 <div class="DetailEx">
            
            <div class="Detail-bEx">
              <p class="deEx">ชื่อ</p>
              <p class="dePhone">เบอร์โทรศัพท์</p>
              <p class="deAdd">ที่อยู่</p>
              <div class="Detail-bsEx">
                <p style="width: 100px; height: 28.8px; color: #7f8285">
                  พรชนก งามสม
                </p>
                <p
                  style="width: 120px;height: 28.8px;color: #7f8285;"
                >
                  081-234-5678
                </p>
                    <p
                  style="width: 179px;height: 28.8px;color: #7f8285;"
                >
           162/4 โครงการชิลค์สุขสวัสดิ์ กรุงเทพมหานคร 10140
                </p>
                 <a href="Redeem02" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30">สั่งเลย</a>
              </div>
            </div>
 </div>
</div>

    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@100&display=swap');
.contra {
    padding-right: 15px;
padding-top: 90px;

}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
.Detail {
  display: table;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  text-align: center;
  margin: auto;
  width: 50%;

  padding: 10px;

  width: 85px;
  left: 40px;
  height: 31px;
}
.Detail-b {
  display: table;
  top: 109px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 20px;
}
.Detail p {
  color: #7f8285;
  width: 270px;
  margin-bottom: 5px;
  height: 70px;

  padding: 0;
  font-style: normal;
  margin-top: 16px;
}
.DetailEx p {
 width: 277%;
    position: relative;
}
p.deEx {
  margin-top: -39px;
}
.DetailEx {
  display: table;
 
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  width: 85px;
  left: 20px;
  height: 31px;
}
.Detail-bEx {
  display: table;
  top: 71px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
}
.Detail-bsEx {
  display: table;
  top: -37px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 106px;
}
.row {
  margin-right: 0px ;
  margin-left: 0px ;
}

.title-page-l {
  width: 100%;
  top: 5px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: Prompt SemiBold;
  letter-spacing: 2px;
    margin-left: 70px;
    margin-top: 20px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  margin-left: 70px;
  text-align: left;
}
.title-page-r {
  display: table;
  top: 27px;
  position: absolute;
  overflow: visible;
  background: rgb(255, 255, 255, 0.3);
  border-radius: 30px;
  width: 85px;
  left: 275px;
  height: 31px;
}
.title-page-r p {
  color: #ffffff;
  padding-top: 10px;
}
.bg-white {
background: #7bc79a;
    border-radius: 10px;
    height: 250px;

    position: relative;
    overflow: visible;
    top: 90px;

    margin-right: auto;
    padding: 10px;
    display: block;
    width:90%;
 
    margin-left: auto;

}
.img-profile {
 display: block;
  margin-left: 9;
  margin-right: 9;
  width: 59px;
  height: 59px;
  float: left;
}
.name-profile {
  font-family: Prompt Medium;
  color: #ffffff;
  padding: 15px 0px 0px 15px;
   font-size: 19px;
}

h1 {
  font-size: 20px;
  margin-top: 0px;
}
p {
  font-size: 16px;
  color: #7f8285;
font-family: 'Prompt', sans-serif;

}
.btn-block {
    display: block;
    width: 90%;
    margin-top: 131px;
    margin-left: auto;
    margin-right: auto;
}
</style>
